import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ModalShell from 'components/global/ModalShell';

const DevelopeDialog = ({ open, handleClose }) => {
    const { t } = useTranslation();
    return (
        <ModalShell open={open} onClose={handleClose} title={t('title.developing')} maxWidth="xs">
            <Box className="flex items-center justify-center py-4">
                <Typography variant="body14" className="text-gray-500 text-center">
                    {t('title.developing')}
                </Typography>
            </Box>
        </ModalShell>
    );
};

export default DevelopeDialog;
